import { useTranslation } from 'react-i18next';
import { FaCrown, FaStar, FaUser } from 'react-icons/fa';

/**
 * 会员等级徽章组件
 */
export function MembershipBadge({ tier, size = 'md', expired = false }) {
  const { t } = useTranslation();
  const config = {
    free: {
      label: t('membership.free'),
      icon: FaUser,
      bgColor: 'bg-surface-highlight/70',
      textColor: 'text-slate-200',
    },
    lite: {
      label: t('membership.lite'),
      icon: FaStar,
      bgColor: 'bg-accent-strong',
      textColor: 'text-white',
    },
    pro: {
      label: t('membership.pro'),
      icon: FaCrown,
      bgColor: 'bg-gradient-to-r from-accent-warm to-accent-soft',
      textColor: 'text-slate-900',
    },
    expired: {
      label: t('membership.expired'),
      icon: FaCrown,
      bgColor: 'bg-rose-500/15 border border-rose-400/30',
      textColor: 'text-rose-200',
    },
  };

  const tierConfig = expired ? config.expired : (config[tier] || config.free);
  const Icon = tierConfig.icon;

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5',
  };

  const iconSizes = {
    sm: 10,
    md: 12,
    lg: 14,
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${tierConfig.bgColor} ${tierConfig.textColor} ${sizeClasses[size]}`}
    >
      <Icon size={iconSizes[size]} />
      {tierConfig.label}
    </span>
  );
}
